import React from 'react'

export default function LogoBoticario({ width = 176 }) {
  return (
    <span style={{ display: 'inline-flex', maxWidth: width }}>
      <svg
        width={width}
        height={0.136 * width}
        viewBox={`0 0 247 32`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M76.5238 4.49576C69.3447 4.49576 63.5183 10.6313 63.5183 18.2479C63.5183 25.8115 69.3447 32 76.5238 32C83.7028 32 89.5293 25.8644 89.5293 18.2479C89.4772 10.6313 83.6508 4.49576 76.5238 4.49576ZM76.5238 29.3554C71.5297 29.3554 68.5644 25.1768 68.5644 18.2479C68.5644 11.266 71.5297 7.1404 76.5238 7.1404C81.4659 7.1404 84.4311 11.3189 84.4311 18.2479C84.4311 25.1768 81.4659 29.3554 76.5238 29.3554Z"
          fill="white"
        />
        <path
          d="M90.6225 7.45836H100.143V31.6304H104.929V7.45836H114.501V4.81372H90.6225V7.45836Z"
          fill="white"
        />
        <path
          d="M124.176 4.81372H119.338V31.5775H124.176V4.81372Z"
          fill="white"
        />
        <path
          d="M150.083 24.1186C148.471 28.6145 144.621 29.3021 142.488 29.3021C137.494 29.3021 134.477 25.1765 134.477 18.2475C134.477 11.3186 137.442 7.19293 142.488 7.19293C146.078 7.19293 148.835 9.09707 150.031 12.4293L150.5 13.7516L152.841 12.588L152.476 11.5301C150.864 7.08715 147.17 4.54829 142.332 4.54829C135.101 4.54829 129.483 10.5781 129.483 18.3004C129.483 26.1285 134.997 31.9996 142.332 31.9996C147.222 31.9996 150.916 29.4608 152.528 25.0707L152.893 24.0128L150.552 22.8492L150.083 24.1186Z"
          fill="white"
        />
        <path
          d="M203.509 26.7639L202.105 22.6911C201.585 21.2101 200.544 19.9936 199.14 19.1473C201.637 18.0366 203.822 15.9208 203.822 12.5886C203.822 7.77536 199.92 4.86626 193.417 4.86626H183.585V31.63H188.423V20.2581H192.637C195.706 20.2581 196.695 21.4746 197.579 23.9077L198.932 27.7688C199.4 29.1969 199.868 30.2548 200.44 31.1011L200.804 31.63H207.307L205.018 29.4614C204.446 28.9325 203.926 27.9804 203.509 26.7639ZM188.423 7.458H193.053C197.111 7.458 198.827 8.9919 198.827 12.5886C198.827 16.0795 197.059 17.6134 193.105 17.6134H188.423V7.458Z"
          fill="white"
        />
        <path
          d="M215.682 4.81372H210.844V31.5775H215.682V4.81372Z"
          fill="white"
        />
        <path
          d="M233.995 4.49576C226.815 4.49576 220.989 10.6313 220.989 18.2479C220.989 25.8115 226.815 32 233.995 32C241.174 32 247 25.8644 247 18.2479C246.948 10.6313 241.122 4.49576 233.995 4.49576ZM233.995 7.0875C238.937 7.0875 241.902 11.266 241.902 18.195C241.902 25.1768 238.937 29.3025 233.995 29.3025C229 29.3025 226.035 25.1239 226.035 18.195C225.983 11.266 229 7.0875 233.995 7.0875Z"
          fill="white"
        />
        <path
          d="M13.0055 4.49576C5.82645 4.49576 0 10.6313 0 18.2479C0 25.8115 5.82645 32 13.0055 32C20.1845 32 26.011 25.8644 26.011 18.2479C26.011 10.6313 20.1845 4.49576 13.0055 4.49576ZM13.0055 29.3554C8.01137 29.3554 5.04612 25.1768 5.04612 18.2479C5.04612 11.266 8.01137 7.1404 13.0055 7.1404C17.9476 7.1404 20.9128 11.3189 20.9128 18.2479C20.9128 25.1768 17.9476 29.3554 13.0055 29.3554Z"
          fill="white"
        />
        <path
          d="M53.2702 15.3389C55.8713 13.9637 57.7441 11.6364 57.7441 8.51574C57.7441 3.12068 53.5303 0 46.2472 0H32.4614V31.8415H47.3917C54.5708 31.8415 58.9926 28.4034 58.9926 22.8497C58.9926 19.1472 56.4956 16.6612 53.2702 15.3389ZM46.4033 14.1224H37.8197V2.64464H45.9351C50.513 2.64464 52.4378 4.3901 52.4378 8.51574C52.3858 12.4298 50.6171 14.1224 46.4033 14.1224ZM37.8197 29.2497V16.767H46.3513C49.0564 16.767 53.5303 17.5604 53.5303 22.9555C53.5303 27.3456 51.5535 29.2497 46.9755 29.2497H37.8197Z"
          fill="white"
        />
        <path
          d="M170.319 0.582016H167.51L154.193 31.6301H157.002L160.955 22.5325H170.475L174.533 31.6301H179.683L168.134 5.7655L170.319 0.582016ZM162.048 19.8879L165.585 11.6366L169.279 19.8879H162.048Z"
          fill="white"
        />
      </svg>
    </span>
  )
}
